// extracted by mini-css-extract-plugin
export var card = "_jt-5";
export var cardSelected = "_jt-4";
export var image = "_jt-3";
export var modal = "_jt-0";
export var modalContent = "_jt-1";
export var table = "_jt-2";